import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {LoginRequest} from "../models/login-request";
import {BehaviorSubject, catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {Token} from "../models/token";
import {StorageService} from "../../../core/services/storage.service";
import {Router} from "@angular/router";
import {environment} from "@env/environment";
import { ChatUiService } from '../../../core/services/chat-ui.service';
import { SecretariaService } from '../../../core/services/secretaria.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private handlerErro: HandlerError;
  private readonly TOKEN_KEY: string = 'trabalho.user.service';
  private loggedIn = new BehaviorSubject<boolean>(false);
  private participantChanges = new BehaviorSubject<Token | undefined>(this.AccessToken);


  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService,
    private storageService: StorageService,
    private router: Router,
    private chatUi: ChatUiService,
    private secretaria: SecretariaService) {
    this.handlerErro = httpErrorHandler.createHandleError(`AuthService`);
  }

  baseUrl = environment.apiUrl;

  login(request: LoginRequest): Observable<BaseResponse<Token> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<Token>>(this.baseUrl + '/Token', request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('login')));
  }

  logoff(){
    // Remover token e redirecionar para login
    this.removeAccessToken();

    // Fechar todos os chats e limpar estados/mensagens
    try {
      this.chatUi.closeAll();
    } catch {}
    try {
      this.secretaria.fechar();
      this.secretaria.limpar();
    } catch {}

    this.router.navigate([`/auth/login/`]);
  }

  setAccessToken(token: Token): void {
    this.storageService.setTypedItem(this.TOKEN_KEY, token);
  }

  get AccessToken(): Token | undefined {
    return this.storageService.getTypedItem<Token>(this.TOKEN_KEY);
  }

  private removeAccessToken(): void {
    this.storageService.removeItem(this.TOKEN_KEY);
  }

}
